namespace GeniuzPOS.Administration {
    export interface PoApprovalGroupForm {
        ApprGroupCode: Serenity.StringEditor;
        ApprGroupName: Serenity.StringEditor;
    }

    export class PoApprovalGroupForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PoApprovalGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoApprovalGroupForm.init)  {
                PoApprovalGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PoApprovalGroupForm, [
                    'ApprGroupCode', w0,
                    'ApprGroupName', w0
                ]);
            }
        }
    }
}
